import ProjectList from "./ProjectList";

const index = {
  list: ProjectList,
};

export default index;
